import { Action } from '@ngrx/store';
import { ICategory } from 'src/app/models/commerce/category.model';


export const SET_CATEGORIES_COMMERCE = '[Categories commerce] Set Categories';
export const UNSET_CATEGORIES_COMMERCE = '[Categories commerce] Unset Categories';


export class SetCategoriesCommerceActions implements Action {
    readonly type = SET_CATEGORIES_COMMERCE;

    constructor(public categories: ICategory[]) { }
}

export class UnsetCategoriesCommerceAction implements Action {
    readonly type = UNSET_CATEGORIES_COMMERCE;
}


export type acciones = SetCategoriesCommerceActions | UnsetCategoriesCommerceAction;
